import { useLazyQuery } from "@apollo/client";
import { FeatureFlagsQuery, FeatureFlagsQueryVariables } from "@ctypes";
import { FEATURE_FLAGS } from "@graphql";

export const useFetchFeatureFlags = () => {
  return useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FEATURE_FLAGS);
};
